import { useEffect } from "react";
import { redirectToLogin } from "../helpers/logout";
import PageLoader from "../views/components/Common/PageLoader";

export default function RedirectToLogin() {
  useEffect(() => {
    redirectToLogin();
  }, []);

  return <PageLoader />;
}
